// The fate of a captive hero (`heroes.captivity`) — English. Merged in
// ./messages.ts.

export const gameHeroesEn = {
  'heroes.captives': 'Heroes you hold',
  'heroes.taken': 'Your heroes, taken',
  'heroes.heldSince': 'Held since tick {n}',
  'heroes.level': 'Level {n}',
  'heroes.takenAt': 'Taken at {q},{r}',
  'heroes.decision': 'Decision',
  'heroes.payRansom': 'Pay the ransom',
  'heroes.noRansom': 'No ransom has been asked',
  'heroes.captor.title': 'What happens to {name}?',
  'heroes.captor.body': 'You hold a hero of another house. They will remember what you decide.',
  'heroes.captor.ransomBody': 'Ask for gold. If nobody pays, the hero is only held.',
  'heroes.captor.holdBody': 'Keep them. A held hero may yet slip away on their own.',
  'heroes.captor.executeBody': 'End it now. A death is remembered as a death.',
  'heroes.captor.releaseBody': 'Let them go. Nothing is gained and nothing is lost.',
  'heroes.quests': 'Hero orders',
  'heroes.noQuests': 'No hero of your house has an order',
  'heroes.giveOrder': 'Give an order',
  'heroes.order': 'Order',
  'heroes.order.slay': 'Slay {n} foes',
  'heroes.order.hunt': 'Hunt {name}',
  'heroes.order.kind.slay': 'Slay',
  'heroes.order.kind.hunt': 'Hunt',
  'heroes.quest.progress': '{made}/{needed}',
  'heroes.quest.due': 'Due at tick {n}',
  'heroes.quest.active': 'Open',
  'heroes.quest.completed': 'Done',
  'heroes.quest.failed': 'Failed',
  'heroes.quest.dialog.title': 'What is {name} for?',
  'heroes.quest.dialog.body':
    'An order is a contract. The hero is paid when it is done, and it runs out on its own if it is not.',
  'heroes.quest.dialog.slayLabel': 'Foes to slay',
  'heroes.quest.dialog.give': 'Give the order',
  'heroes.quest.dialog.noTargets': 'No enemy hero is in sight to hunt',
  'heroes.quest.dialog.cancel': 'Not now',
} as const;
